import React, {useMemo, useRef, useState} from 'react';
import Card from "../../../components/card";
import useFetchData from "../hooks/use-fetch-data";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import {useNavigate} from "react-router-dom";
import StatusCellRenderer from "./status-cell-renderer";
import general from "../../../utils/general";

const AttendancesTable = ({project, setIsLoading, onlySeeAttendances}) => {
    const {attendances} = useFetchData(project);
    const navigate = useNavigate();

    const [columnDefs] = useState([
        { field: "id", headerName: "ID", width: 70 },
        { field: "date_initial", headerName: "Abertura",
            cellRenderer: params => {
                return general.formatDate(params.value)
            }
        },
        { field: "status", headerName: "Status", cellRenderer: StatusCellRenderer, width: 180 },
        { field: "project_name", headerName: "Projeto" },
        { field: "product", headerName: "Produto (Localização)", flex: 1, minWidth: 200 },
        { field: "requester", headerName: "Solicitante" }
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const onCellClicked = (cell) => {
        if (!onlySeeAttendances){
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
                navigate(`/hardware-attendances/form/${cell.data.id}`)
            }, 100);
        }
    }

    return (
        <Card title="Chamados" wrapperClass="mt-5">
            <div className={"ag-theme-quartz grid"}>
                <AgGridReact
                    ref={gridRef}
                    rowHeight={32}
                    rowData={attendances}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={false}
                    suppressRowClickSelection={true}
                    suppressCellFocus={true}
                    onCellClicked={onCellClicked}
                    gridOptions={{localeText: LocalizationAgGrid}}
                    domLayout='autoHeight'
                />
            </div>
        </Card>
    );
};

export default AttendancesTable;